// Because JSDOM (part of Jest) does not support mock of native browser APIs like `window.location` or `navigator`,
// we create wrappers for these functionalities.
// This allows us to mock them in tests without affecting the global objects directly.
// This is useful for testing components that rely on these APIs without causing side effects in the test environment.)

export const windowWrapper = {
  location: {
    getHostName: () => {
      return window.location.hostname;
    },
    setHref: (href: string): void => {
      window.location.href = href;
    },
    reloadPage: (): void => {
      window.location.reload();
    },
  },
};

export const navigatorWrapper = {
  serviceWorker: {
    canRegister: (): boolean => navigator?.serviceWorker?.register !== undefined,
    register: (url: string, options?: RegistrationOptions): Promise<ServiceWorkerRegistration> => {
      return navigator.serviceWorker.register(url, options);
    },
    subscribeOnMessage: (event: ServiceWorkerContainer['onmessage']) => {
      if (navigator?.serviceWorker) {
        navigator.serviceWorker.onmessage = event;
      } else {
        console.warn('Service Worker onmessage is not supported in this browser.');
      }
    },
  },
};
